export const NavBarType = {
  DEFAULT: 'default',
  MODAL_WITH_BACK: 'modal_with_back',
  MODAL_WITH_CLOSE: 'modal_with_close'
} as const;

export type NavBarType = (typeof NavBarType)[keyof typeof NavBarType];
